export default class AIFlaggedIssueViewModel {
    public isActive: boolean = false;
    public templateId: number = 0;
    public sectionId: number = 0;
    public questionId: number = 0;
}